import { render, staticRenderFns } from "./Fines.vue?vue&type=template&id=5b779220"
import script from "./Fines.vue?vue&type=script&lang=js"
export * from "./Fines.vue?vue&type=script&lang=js"
import style0 from "./Fines.vue?vue&type=style&index=0&id=5b779220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports